//= ============================================================================
// Dynamic form
//= ============================================================================


var Reverb = window.Reverb || {};

(function (global) {
  'use strict';

  Reverb.Listing = Reverb.Listing || {};
  // This is a temporary home that needs to be decomposed into individual modules
  Reverb.Listing.General = (function () {
    var startedForm = false;
    var hasCustomTitle = false;

    function bindEndListingChangeHandler() {
      $('[id^="end-listing-reason-"]').change(function () {
        var other = $(this).parents('.dialog').find('#other_reason');
        if ($(this).val() === 'other') {
          toggleInput(other);
        } else {
          if (other.is(':visible')) {
            toggleInput(other);
          }
        }
      });
    }

    function bindHintFadeIns() {
      $('.hint-faded').waypoint(function (direction) {
        fadeInOpacity($(this));
      }, { offset: 500 });

      $('.hint-btm').waypoint(function (direction) {
        fadeInOpacity($(this));
      }, { offset: 650 });

      $('.g-container').find(':input').focus(function () {
        var hint = $(this).closest('.g-container').find('.hint-faded');
        fadeInOpacity(hint);
      });
    }

    function fadeInOpacity($element) {
      $element.animate({ opacity: 1.0 });
    }

    function setLastModuleMargin() {
      $('.g-container.mb-4').last().css('margin-bottom', '28px');
    }

    function toggleInput($inputContainer) {
      $inputContainer.toggle();
      $inputContainer.toggleClass('required');
      var input = $inputContainer.find('input');
      input.toggleClass('required');
      input.prop('disabled', !input.prop('disabled'));
      input.prop('required', !input.prop('required'));
    }

    function isNotEmptyString(string) {
      if (string === undefined) {
        return false;
      }

      var emptyStringPattern = /^\s*$/;
      return !emptyStringPattern.test(string);
    }

    function shouldAutoGenerateItemTitle() {
      return isNewRecord() && !hasCustomTitle;
    }

    function recordTitleCustomization() {
      $(document).on('keydown', '#product_title', function () {
        hasCustomTitle = true;
      });
    }

    function autoGenerateItemTitle() {
      $(document).on('blur listing.autocomplete.selected', '#product_make, #product_model, #product_year, #product_finish', function () {
        if (shouldAutoGenerateItemTitle()) {
          var nonEmptyTitleAttributes = $.grep([
            $('#product_make').val(),
            $('#product_model').val(),
            $('#product_year').val(),
            $('#product_finish').val()
          ], isNotEmptyString);

          var title = $.trim(nonEmptyTitleAttributes.join(' '));

          $('#product_title').val(title);
        }
      });
    }

    function productForm() {
      return $('.listing-editor form');
    }

    function isNewRecord() {
      return productForm().prop('id') == 'new_product';
    }

    function setupAutoComplete() {
      if (typeof(Reverb.Autocomplete) !== 'undefined') {
        autocompleteForElement($('#product_finish'), Reverb.Autocomplete.finishes);
      }
    }

    function autocompleteForElement($el, lookup) {
      $el.autocomplete({
        lookup: lookup,
        minChars: 2,
        onSelect: function (suggestion) {
          $(this).trigger('listing.autocomplete.selected');
        }
      });
    }

    function init() {
      $('form#new_product input').bind('change keydown', function () {
        if (startedForm) { return; }
        startedForm = true;
      });

      autoGenerateItemTitle();
      recordTitleCustomization();
      bindEndListingChangeHandler();
      bindHintFadeIns();
      setLastModuleMargin();
      $(document).ready(setupAutoComplete);
    }

    return {
      init: init
    };
  })();

  //= =============================================================================
  // On DOM load
  //= =============================================================================
  $(function () {
    Reverb.Listing.General.init();
  });
})(window);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/listing/general.js